import { hash } from '@ember/helper';

import { not } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsShopifyStoreComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar>
        <:content>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='storeId' />
            <fieldset.field @property='accessToken' />
            <fieldset.field @property='revokationUrl' />
            <fieldset.field @property='showShopBranding' @type='checkbox' />
            {{#if @model.showShopBranding}}
              <fieldset.field @property='shopBrandingName' />
            {{/if}}
          </form.fieldset>
        </:content>

        <:sidebar>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='contentOwnerChannel'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />
            <fieldset.field @property='productSync' @type='checkbox' />
          </form.fieldset>

          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='channel'
              @type='belongs-to'
              @disabled={{not @model.productSync}}
              @on={{hash openNewRecord=false}}
            />
            <fieldset.field
              @property='taxa'
              @type='has-many'
              @disabled={{not @model.productSync}}
            />
          </form.fieldset>

          <form.sections.meta />

        </:sidebar>
      </ContentWithSidebar>
    </Form>
  </template>
}
